
export type SecurityViewTypes = 'all' | 'equity' | 'etfs';

export function isOfTypeSecurityView (keyInput: string): keyInput is SecurityViewTypes {
    return ['all', 'equity', 'etfs' ].includes(keyInput);
}

export type TimeframeTypes = 'monthly' | 'weekly' | 'daily' | 'two_hour' | 'fifteen_minute' | 'three_minute';

export function isOfTypeTimeframe (keyInput: string): keyInput is TimeframeTypes {
    return ['monthly', 'weekly', 'daily', 'two_hour', 'fifteen_minute', 'three_minute' ].includes(keyInput);
}

export const timeframeOrdering = ['monthly', 'weekly', 'daily', 'two_hour', 'fifteen_minute', 'three_minute'];

export type ViewTypes = 'timeframes-list' | 'traders-list' | 'all' | 'intraday' | 'near_term' | 'short_term' | 'intermediate';

export function viewTypeIsMultiView (view: ViewTypes): view is ViewTypes {
    return ['timeframes-list', 'traders-list'].includes(view);
}

export function isOfTypeView (keyInput: string): keyInput is ViewTypes {
    return ['timeframes-list', 'traders-list', 'all', 'intraday', 'near_term', 'short_term', 'intermediate'].includes(keyInput);
}

export type TraderTypes = 'all' | 'intraday' | 'near_term' | 'short_term' | 'intermediate';

export function isOfTypeTrader (keyInput: string): keyInput is TraderTypes {
    return ['all', 'intraday', 'near_term', 'short_term', 'intermediate'].includes(keyInput);
}

export const traderToTimeframes = Object({
    intraday: ["two_hour", "fifteen_minute", "three_minute"], 
    near_term: ["daily", "two_hour", "fifteen_minute"], 
    short_term: ["weekly", "daily", "two_hour"], 
    intermediate: ["monthly", "weekly", "daily"]
});

export const traderToTimeframeAbbreviations = Object({
    intraday: ["2hr", "15min", "3min"], 
    near_term: ["D", "2hr", "15min"], 
    short_term: ["W", "D", "2hr"], 
    intermediate: ["M", "W", "D"]
});

export const conditionsOrdering = ["Very Bearish", "Bearish", "Slightly Bearish", "Slightly Bearish to Neutral", "Neutral to Slightly Bearish", "Neutral", "Neutral to Slightly Bullish", "Slightly Bullish to Neutral", "Slightly Bullish", "Bullish", "Very Bullish"];

export const privilegedLevels = ['level1', 'level2']; 

export const privilegedTimeframes = ['fifteen_minute', 'three_minute'];

export const privilegedTraderTypes = ['near_term', 'intraday'];